import { api } from '../../DefaultService';
import { ISponteCreateProps, ISponteProps, ISponteUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/sponte';

export const createSponteIntegrationAsync = async (
  data: ISponteCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSponteIntegrationsAsync = async (): Promise<
  ISponteProps[]
> => {
  return await api
    .get<ISponteProps[]>(`${ENDPOINT}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSponteIntegrationByIdAsync = async (
  id: number,
): Promise<ISponteProps> => {
  return await api
    .get<ISponteProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSponteIntegrationAsync = async ({
  id,
  data,
}: ISponteUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSponteIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
